module.exports = __webpack_public_path__ + "img/bulletin-hotel.b42b871c.png";